import React from "react";
import { useEffect } from "react";
import styles from "./OtpInput.module.css";
import Input from "react-otp-input";
import { Stack, Typography } from "@mui/material";
import constants from "../../../core/constants/Constants";
import strings from "../../../strings/Strings";

interface OtpInputProps {
  otp: any;
  setOtp: any;
  otpTimer: number;
  resendOtp: () => void;
  setOtpTimer: any;
  screen?: string;
  isShowSendCodeBtn: boolean;
  handleSendCode?: () => void;
}

export const OtpInput = ({
  otp,
  setOtp,
  otpTimer,
  resendOtp,
  setOtpTimer,
  screen,
  isShowSendCodeBtn,
  handleSendCode
}: OtpInputProps) => {
  useEffect(() => {
    const timer: any =
      otpTimer > 0 && setInterval(() => setOtpTimer(otpTimer - 1), 1000);
    return () => clearInterval(timer);
  }, [otpTimer]);

  return (
    <>
      <div className={styles["container"]} data-testid="otpinput">
        <Input
          value={otp}
          numInputs={4}
          onChange={(e: any) => setOtp(e)}
          separator={<span className={styles["otp-input-seperator"]}></span>}
          isInputNum={true}
          shouldAutoFocus={true}
          placeholder="----"
          inputStyle={{
            border: "1px solid #576078",
            outline: "none",
          }}
          focusStyle={{
            border: "1px solid #576078",
            outline: "none",
          }}
        />
        <Stack
          spacing={3}
          justifyContent={"center"}
          className={styles["resend-otp-container"]}
        >
          <Typography
            variant="body1"
            className={
              otpTimer === constants.otpInitialLength
                ? styles["resend-otp"]
                : styles["resend-otp-disabled"]
            }
            onClick={resendOtp}
          >
            {otpTimer > 9
              ? otpTimer === constants.otpInitialLength
                ? strings.resendOtp
                : `${strings.resendOtpIn} ${otpTimer} Sec`
              : otpTimer === constants.otpInitialLength
                ? strings.resendOtp
                : `${strings.resendOtpIn} 0${otpTimer} Sec`}
          </Typography>
        </Stack>
      </div>
    </>
  );
};
